import { useAuth } from "../context/AuthContext";
import { isAdmin, useBan } from "../lib/admin";
import { useNow } from "../lib/room";
import { clockLeft } from "../lib/banTime";
import { useT } from "../i18n";
import Pic from "./pics";

// A banned player gets this and nothing else: no games, no menu, no links, just
// how long is left. It covers the whole site (see BanGate) and goes away by
// itself when a temporary ban ends (useBan re-checks at that moment).
export function BanWall({ ban }) {
  const t = useT();
  const now = useNow(1000);
  const temporary = !!ban.until;
  const left = temporary ? clockLeft(ban.until - now) : null;
  return (
    <div className="ban-wall" role="alert">
      <div className="ban-wall-card">
        <div className="ban-wall-icon" aria-hidden>
          <Pic name="block" />
        </div>
        <h1>{temporary ? t("You're banned for now") : t("You're banned")}</h1>
        {temporary ? (
          <>
            <p className="muted">{t("You can play again in")}</p>
            <div className="ban-wall-timer" aria-live="off">
              {left.days > 0 && <span className="ban-wall-days">{t("{n}d", { n: left.days })}</span>}
              <span>{left.time}</span>
            </div>
          </>
        ) : (
          <p className="muted">{t("This account was banned for breaking the rules. If you think that's a mistake, contact us.")}</p>
        )}
        {ban.reason && <p className="ban-wall-reason">{t("Reason: {reason}", { reason: ban.reason })}</p>}
        {temporary && <p className="muted small">{t("This ban was for breaking the rules. If you think that's a mistake, contact us.")}</p>}
      </div>
    </div>
  );
}

// Wraps the whole app. The site's owner is never walled out of their own site.
export default function BanGate({ children }) {
  const { user } = useAuth();
  const ban = useBan(user?.uid);
  if (ban.banned && !isAdmin(user)) return <BanWall ban={ban} />;
  return children;
}
